import script from "./DocumentArrowUpIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentArrowUpIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__